import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

const apiFetchBalanceOnHandExpectedInfo = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getBalanceOnHandExpectedInfo',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
      impcCode: payload.params.impcCode,
    },
  });
  return axios.get(serviceUrl);
};

export default apiFetchBalanceOnHandExpectedInfo;
